import yearService from "../../services/year.service";


    export const state ={
        years:[],

    }
    export const actions = {
        fetch_years({commit}, page){
            return  yearService.get_years(page).then(
                data => {
                    commit ('SET_YEAR', data.data.data);
                    return Promise.resolve(data.data);
                }, error => {
                    commit('AssetsFailed');
                    return Promise.reject(error);
                }
            );
        },
        fetch_totals({commit},){
            return  yearService.fetch_totals().then(
                data => {
                    // console.log(data);
                    
                    commit ('SET_TOTALS', data.data);
                    return Promise.resolve(data.data);
                }, error => {
                    commit('AssetsFailed');
                    return Promise.reject(error);
                }
            );
        },

    }
    export const mutations = {
        
        SET_YEAR(state,years){
            state.years = years
        },
        SET_TOTALS(state,totals){
            state.totals = totals
        },
       
    }
    export const getters = {
        get_years(state){
            return state.years
        },
        get_totals(state){
            return state.totals
        },
        

    }


